import React from 'react';
import styled from '@emotion/styled';
import { Flex, Icon } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';
import { themeGet } from 'styled-system';

import useScrollIntoView from '@/hooks/useScrollIntoView';
import FaqCategory from '@/propTypes/FaqCategory';

const CategoryLink = styled(Flex)`
  justify-content: space-between;
  padding: ${themeGet('space.5')};
  background-color: white;
  border-radius: ${themeGet('radii.default')};
  color: inherit;

  &:focus {
    outline-color: ${themeGet('colors.ui.linkFocus')};
  }
`;

const Category = ({ category }) => {
  const scrollIntoView = useScrollIntoView(`#${category.slug}`);
  return (
    <CategoryLink
      width={['100%', null, '305px']}
      mt={4}
      mr={['auto', null, 5]}
      ml={['auto', null, 0]}
      onClick={scrollIntoView}
      aria-label={category.name}
    >
      {category.name}
      <Icon name="chevronRight" color="red" />
    </CategoryLink>
  );
};

Category.propTypes = {
  category: PropTypes.shape(FaqCategory).isRequired,
};

export default Category;
